import modelBaseV2 from "../model-base-v2.model";

const DataInputModel = {
  getConfigDataInput: () => {
    return modelBaseV2.get(
      "/api/MasterConfiguration/data?RecordType=DataInputType"
    );
  },

  downloadExcelTemplate: (type, fileName = "template") => {
    const exportConfig = {
      storedProcedureCode: "24",
      params: [
        {
          code: "66",
          value: type,
        },
      ],
    };
    return modelBaseV2.postDownload(
      "/api/executesp/export/file",
      {
        body: exportConfig,
      },
      fileName
    );
  },

  uploadExcel: (formData, type) => {
    return modelBaseV2.post("/api/datainput/web/:dataType", {
      body: formData,
      params: { dataType: type },
    });
  },

  downloadResult: (fileId, filename) => {
    return modelBaseV2.getDownload(
      "/api/file/temp/:fileId",
      {
        params: { fileId },
      },
      filename
    );
  },
};

export default DataInputModel;
